/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UserEndpointService, UserLoginDto } from 'openapi-generated';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  styleUrl: './update-user.component.scss',
})
export class UpdateUserComponent {
  data: UserLoginDto;

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<UpdateUserComponent>,
    private snackBar: MatSnackBar,
    private userService: UserEndpointService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) data: UserLoginDto,
  ) {
    this.data = data;
  }

  /**
   * Form validation will start after the method is called
   */
  updateUser(dto: UserLoginDto) {
    this.userService.update(this.authService.getUsername()!, dto).subscribe({
      next: () => {
        this.snackBar.open('Successfully updated user', 'Close', { duration: 3000 });
        this.authService.logoutUser();
        this.dialogRef.close();
        this.router.navigate(['/admin/']);
      },
      error: error => {
        console.log(error);
        this.defaultServiceErrorHandling(error);
      },
    });
  }

  cancel() {
    console.log('Cancel Update User');
  }

  private defaultServiceErrorHandling(error: HttpErrorResponse) {
    let errorMessage = '';
    console.log(JSON.stringify(error));
    if (typeof error.error === 'object') {
      errorMessage = error.error.error;
    } else {
      errorMessage = error.error;
    }
    this.snackBar.open('Error: ' + errorMessage, 'Close', {
      duration: 5000,
    });
  }
}
